export const DiscoverSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6093 2.13263L6.71827 4.11139C5.56602 4.39748 4.39787 5.56566 4.11179 6.71796L2.13309 14.6092C1.53709 16.9932 2.99927 18.4634 5.39119 17.8674L13.2822 15.8966C14.4265 15.6105 15.6026 14.4343 15.8887 13.29L17.8674 5.39083C18.4634 3.00678 16.9932 1.53662 14.6093 2.13263Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.65 12.3C11.1136 12.3 12.3 11.1136 12.3 9.65C12.3 8.18644 11.1136 7 9.65 7C8.18644 7 7 8.18644 7 9.65C7 11.1136 8.18644 12.3 9.65 12.3Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BrandsSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.18279 13.3095C2.94636 12.0731 2.32815 11.4549 2.09811 10.6528C1.86807 9.85072 2.06467 8.9988 2.45785 7.295L2.68459 6.31246C3.01538 4.87905 3.18078 4.16234 3.67155 3.67155C4.16234 3.18078 4.87905 3.01538 6.31246 2.68459L7.295 2.45785C8.9988 2.06467 9.85072 1.86807 10.6528 2.09811C11.4549 2.32815 12.0731 2.94636 13.3095 4.18279L14.7732 5.6465C16.9244 7.79769 18 8.87328 18 10.2098C18 11.5464 16.9244 12.622 14.7732 14.7732C12.622 16.9244 11.5464 18 10.2098 18C8.87328 18 7.79769 16.9244 5.6465 14.7732L4.18279 13.3095Z"
        stroke="#676A79"
      />
      <path
        d="M8.351 8.57756C9.00188 7.92669 9.00188 6.87141 8.351 6.22054C7.70013 5.56966 6.64486 5.56966 5.99398 6.22054C5.34311 6.87141 5.34311 7.92669 5.99398 8.57756C6.64486 9.22843 7.70013 9.22843 8.351 8.57756Z"
        stroke="#676A79"
      />
      <path
        d="M9.61808 15.4167L15.434 9.60071"
        stroke="#676A79"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const MenSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3578_2871)">
        <path
          d="M17.2213 15.6016C16.7819 14.8518 16.102 14.4009 15.4478 14.1C14.7932 13.7995 14.1457 13.6371 13.7561 13.4899C13.4479 13.3753 13.1111 13.1961 12.8712 13.0028C12.7512 12.9067 12.6563 12.8072 12.5987 12.7207C12.54 12.633 12.5217 12.5659 12.522 12.5207C12.522 12.2106 12.522 12.0707 12.522 11.5993C12.9349 11.1397 13.5282 10.4276 13.7721 9.29852C13.8572 9.26004 13.9415 9.21676 14.0227 9.16031C14.2246 9.02098 14.396 8.81813 14.5413 8.54313C14.6877 8.26668 14.8169 7.91301 14.9551 7.42981C15.025 7.1843 15.0573 6.97137 15.0573 6.78203C15.0579 6.56344 15.0127 6.37359 14.9301 6.21961C14.8298 6.03086 14.6795 5.91227 14.5393 5.84149C14.5449 5.82914 14.55 5.8193 14.5556 5.80609C14.6604 5.55523 14.768 5.20801 14.7685 4.8091C14.7668 4.1902 14.641 3.01961 13.9755 1.96141C13.6426 1.4341 13.1695 0.938282 12.5152 0.579258C11.8616 0.219688 11.0322 -0.000273183 10.0002 2.54639e-07C8.96805 -0.000273183 8.13875 0.219688 7.48504 0.579258C6.50207 1.11863 5.93406 1.96195 5.62027 2.7657C5.30508 3.57195 5.2323 4.34391 5.23176 4.80914C5.2323 5.20805 5.33992 5.55523 5.44469 5.80613C5.45059 5.8202 5.45621 5.83086 5.46211 5.84406C5.43656 5.85672 5.41238 5.86516 5.38625 5.88113C5.26992 5.95332 5.15223 6.0657 5.07023 6.21965C4.98766 6.37363 4.94238 6.56348 4.94269 6.78207C4.94297 6.97195 4.97527 7.18492 5.04519 7.42984C5.23004 8.07375 5.39691 8.48949 5.61297 8.79461C5.72113 8.94602 5.84387 9.06766 5.97762 9.16039C6.05879 9.21684 6.14309 9.26008 6.2282 9.29859C6.47203 10.4276 7.06531 11.1398 7.47828 11.5994C7.47828 12.0702 7.47828 12.2107 7.47828 12.5208C7.47914 12.5593 7.45973 12.6304 7.39566 12.7216C7.30238 12.8584 7.11895 13.022 6.90633 13.1602C6.69422 13.2993 6.45262 13.417 6.25008 13.4883C5.98687 13.581 5.60789 13.685 5.19297 13.8313C4.5707 14.0519 3.85719 14.3696 3.28578 14.9398C2.71297 15.5082 2.30625 16.3413 2.30961 17.4841C2.30961 17.6297 2.31605 17.7802 2.32926 17.9364C2.3377 18.0336 2.37199 18.1143 2.41324 18.1831C2.49219 18.3112 2.59922 18.4104 2.73348 18.5115C2.96832 18.6859 3.29477 18.857 3.71867 19.0264C4.98703 19.5304 7.13242 19.9993 10.0001 20.0001C12.3301 20.0001 14.185 19.6888 15.4775 19.3031C16.1242 19.1096 16.6296 18.8989 16.9925 18.6898C17.1746 18.5842 17.3209 18.4805 17.4367 18.3679C17.4946 18.3111 17.5451 18.2516 17.587 18.183C17.6282 18.1142 17.6625 18.0336 17.671 17.9364C17.6839 17.7802 17.6904 17.6302 17.6904 17.4852C17.6912 16.7236 17.514 16.1 17.2213 15.6016ZM12.7206 13.6736C12.7349 13.6832 12.7509 13.69 12.7655 13.6995L11.6612 16.398L10.3296 14.7332L12.2697 13.3076C12.4023 13.443 12.5548 13.5646 12.7206 13.6736ZM6.81141 9.01398L6.77937 8.83281L6.60633 8.77098C6.49621 8.73164 6.41223 8.69149 6.33891 8.64063C6.23074 8.56422 6.13269 8.46 6.01812 8.24621C5.90488 8.03383 5.78492 7.71668 5.65375 7.25625C5.59617 7.05484 5.57562 6.89836 5.57562 6.78207C5.57594 6.64723 5.60176 6.56801 5.62816 6.51828C5.66809 6.44578 5.71695 6.41488 5.7793 6.38992C5.82199 6.37363 5.86723 6.36746 5.89277 6.3652L6.31836 6.45594L6.82965 7.06246L7.10269 6.99895C7.10269 6.99895 7.19371 5.29207 7.19371 4.81731C7.19371 4.34285 8.10391 4.07957 9.99984 4.07957C11.8961 4.07957 12.8063 4.34281 12.8063 4.81731C12.8063 5.29207 12.8973 6.99895 12.8973 6.99895L13.1704 7.06246L13.7252 6.40453L14.0918 6.36492C14.112 6.36434 14.2126 6.37418 14.2792 6.41856C14.3154 6.4416 14.3449 6.46855 14.3719 6.51828C14.3983 6.56801 14.4241 6.64695 14.4247 6.78207C14.4247 6.89836 14.4039 7.05453 14.3466 7.25625C14.1721 7.8709 14.0157 8.22824 13.8721 8.42656C13.8002 8.52656 13.7345 8.58949 13.6614 8.64063C13.5881 8.69149 13.5041 8.73164 13.394 8.77098L13.2209 8.83281L13.1889 9.01398C12.9864 10.1481 12.4021 10.7857 11.9705 11.2664L11.8893 11.3566V11.4782C11.8893 12.0533 11.8893 12.1848 11.8893 12.5207C11.8896 12.6724 11.9315 12.8123 11.9947 12.9382L10.0002 14.4041L8.0025 12.936C8.06656 12.8113 8.11039 12.6736 8.11094 12.5207C8.11094 12.1848 8.11094 12.0536 8.11094 11.4782V11.3566L8.02973 11.2664C7.59824 10.7857 7.01394 10.148 6.81141 9.01398ZM7.50191 13.5102C7.58226 13.4461 7.6584 13.3781 7.72863 13.3062L9.67062 14.7333L8.33906 16.398L7.23508 13.7001C7.32719 13.6405 7.4168 13.5775 7.50191 13.5102ZM17.0412 17.8611C17.0277 17.8824 16.978 17.9383 16.8909 18.0021C16.726 18.1263 16.4394 18.2825 16.0512 18.437C14.8834 18.9033 12.7989 19.368 10.0002 19.3674C7.7275 19.3674 5.92734 19.0623 4.70391 18.6966C4.09289 18.5145 3.62516 18.3156 3.32398 18.1415C3.17344 18.055 3.06527 17.974 3.00629 17.9156C2.97988 17.8903 2.96527 17.8713 2.95852 17.8605C2.94844 17.7302 2.9425 17.6038 2.9425 17.4841C2.94336 16.8178 3.09223 16.3157 3.32426 15.9166C3.67148 15.3193 4.22348 14.937 4.81371 14.6648C5.40391 14.3923 6.01406 14.2411 6.46019 14.0849C6.58016 14.0422 6.70516 13.9869 6.83043 13.9259L8.20918 17.297L10.0001 15.058L11.7909 17.297L13.1705 13.9242C13.2916 13.9829 13.4138 14.0377 13.5341 14.0827C13.8335 14.1945 14.2018 14.2978 14.5923 14.4372C15.1775 14.6451 15.8014 14.9322 16.2652 15.3946C16.7273 15.8593 17.0538 16.4868 17.0574 17.4852C17.0575 17.6048 17.0519 17.7304 17.0412 17.8611Z"
          fill="#676A79"
        />
        <path
          d="M9.99117 18.7174C10.1401 18.7174 10.2609 18.5966 10.2609 18.4477C10.2609 18.2987 10.1401 18.178 9.99117 18.178C9.84223 18.178 9.72149 18.2987 9.72149 18.4477C9.72149 18.5966 9.84223 18.7174 9.99117 18.7174Z"
          fill="#676A79"
        />
        <path
          d="M10.0091 17.0452C10.1581 17.0452 10.2788 16.9245 10.2788 16.7755C10.2788 16.6266 10.1581 16.5059 10.0091 16.5059C9.8602 16.5059 9.73945 16.6266 9.73945 16.7755C9.73945 16.9245 9.8602 17.0452 10.0091 17.0452Z"
          fill="#676A79"
        />
      </g>
      <defs>
        <clipPath id="clip0_3578_2871">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WomenSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.60379 10.284C5.14218 10.3399 4.97482 10.6085 4.97482 11.0346C4.97482 11.3187 5.27977 11.5535 5.88954 11.7388C6.57814 16.1767 13.7029 16.1767 14.1314 11.3813C14.6937 11.0469 14.9748 10.8053 14.9748 10.6566C14.9748 10.3833 14.8725 10.1907 14.3426 10.0238"
        stroke="#676A79"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.64149 8.35718C7.26808 7.10714 7.49848 5.85718 7.49848 5.85718C7.49848 5.85718 9.03074 7.69394 13.3082 8.35718"
        stroke="#676A79"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.14214 3.15662C7.30043 3.2854 5.85783 4.41871 4.95855 5.74255C4.5412 6.35702 4.24464 7.0082 4.08062 7.60974L4.01812 7.86462C3.91179 8.36021 3.90549 8.79927 3.99175 9.14099L3.74761 9.28064C3.62489 8.86909 3.63339 8.35504 3.75054 7.80896C3.9021 7.10258 4.23741 6.3213 4.73198 5.59314C5.6656 4.21876 7.18305 3.01541 9.14214 2.88611V3.15662ZM9.84136 2.88123C11.756 2.95632 13.084 3.649 13.9693 4.62341C14.8148 5.55418 15.2444 6.73158 15.4107 7.84412L15.1392 7.87146C14.9773 6.80007 14.5631 5.68134 13.7652 4.8031C12.9355 3.88992 11.683 3.22534 9.84136 3.15076V2.88123Z"
        fill="#676A79"
        stroke="#676A79"
        stroke-width="0.7"
      />
      <path
        d="M9.64832 1.26831C9.84306 1.3254 10.0173 1.41959 10.1688 1.5271C10.4054 1.695 10.6076 1.91037 10.7714 2.11792C10.9031 2.28487 11.0109 2.45138 11.0946 2.5896C11.075 2.59577 11.0546 2.60235 11.0331 2.60913C10.9563 2.63335 10.8915 2.65272 10.8378 2.66968C10.751 2.52055 10.6297 2.32745 10.4774 2.13452C10.3167 1.93089 10.127 1.73185 9.91688 1.58276C9.82426 1.51704 9.73045 1.46629 9.63856 1.42651L9.64832 1.26831ZM8.94227 1.33765C8.63173 1.35389 8.41761 1.42184 8.22059 1.55347C7.97885 1.71497 7.75739 1.97729 7.46571 2.38354L7.23622 2.27612C7.49657 1.92066 7.71887 1.66377 7.9745 1.49292C8.24987 1.30893 8.55721 1.22706 8.95008 1.21069L8.94227 1.33765Z"
        fill="#676A79"
        stroke="#676A79"
        stroke-width="0.7"
      />
      <path
        d="M9.14149 10.0239C9.14149 9.73559 9.14149 9.46349 9.14149 9.19055"
        stroke="#676A79"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8082 10.0239C10.8082 9.74763 10.8082 9.46745 10.8082 9.19055"
        stroke="#676A79"
        stroke-width="0.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.3459 16.2673C14.4402 16.639 15.9596 17.4506 16.8635 18.45L16.6975 18.5496C15.8477 17.5846 14.4058 16.7912 12.3957 16.4158C12.3747 16.3955 12.3525 16.3757 12.3293 16.3582L12.3459 16.2673ZM11.5666 16.6248L11.4992 16.9812L11.5715 16.9919C11.5344 17.071 11.4971 17.154 11.4543 17.2361C11.2428 17.6417 10.9212 18.1073 10.3225 18.2244L10.3293 18.0769C10.4794 18.0357 10.6165 17.9645 10.7404 17.8621C10.9418 17.6955 11.0953 17.4625 11.2287 17.2068C11.2924 17.0848 11.3486 16.9622 11.4016 16.8474C11.4541 16.7337 11.5041 16.6261 11.5539 16.5349V16.5339C11.5673 16.5095 11.5827 16.4866 11.5969 16.4636L11.5666 16.6248ZM8.14377 16.5759C8.22277 16.7469 8.33908 16.9695 8.49728 17.1921C8.77112 17.5774 9.14618 17.9335 9.62912 18.0652L9.62326 18.2078C9.00177 18.0691 8.5641 17.6332 8.28049 17.2341C8.22768 17.1598 8.17982 17.0855 8.13596 17.0134C8.13888 17.0125 8.14156 17.0121 8.14377 17.0115L8.14474 17.0105C8.14582 17.0102 8.14683 17.0098 8.14767 17.0095L8.14963 17.0085L8.15158 17.0076L8.15256 17.0085L8.17307 17.0017C8.17816 16.9998 8.18691 16.9962 8.1965 16.9919L8.11154 16.8044L8.08517 16.5906C8.10583 16.5852 8.12545 16.5807 8.14377 16.5759ZM7.10471 16.5505L7.1506 16.5916C6.76284 16.7173 6.27097 16.881 5.76096 17.0613C5.1897 17.2631 4.59708 17.4856 4.1008 17.699C3.84058 17.8108 3.62095 17.9146 3.44748 18.0066C3.39697 18.0334 3.34896 18.0618 3.30295 18.0886L3.17697 17.9753C3.39274 17.8518 3.66834 17.7195 3.97287 17.5886C4.47766 17.3717 5.07747 17.1469 5.65158 16.9441C6.18981 16.7539 6.70711 16.5824 7.10471 16.4539V16.5505Z"
        fill="#676A79"
        stroke="#676A79"
        stroke-width="0.7"
      />
    </svg>
  );
};

export const PostsSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.03198 20.0157C2.21832 21.1414 3.19641 22 4.375 22H18.625C19.9367 22 21 20.9367 21 19.625V15.1007M2.03198 20.0157C2.01095 19.8886 2 19.7581 2 19.625V5.375C2 4.06332 3.06332 3 4.375 3H18.625C19.9367 3 21 4.06332 21 5.375V15.1007M2.03198 20.0157L6.56905 15.4786C7.37658 14.772 8.5576 14.6947 9.45038 15.2899L10.0551 15.6929C10.9155 16.2666 12.0485 16.2175 12.8561 15.5715L16.0007 13.0556C16.8023 12.4144 17.9188 12.3642 18.7708 12.9137C18.8652 12.9746 18.9493 13.0501 19.0288 13.1296L21 15.1007M10.3125 8.9375C10.3125 10.2492 9.24921 11.3125 7.9375 11.3125C6.62582 11.3125 5.5625 10.2492 5.5625 8.9375C5.5625 7.62582 6.62582 6.5625 7.9375 6.5625C9.24921 6.5625 10.3125 7.62582 10.3125 8.9375Z"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const StyleSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_500_5600)">
        <path
          d="M9.57938 3H4.125C3.50368 3 3 3.50368 3 4.125V10.8491C3 11.4705 3.50368 11.9741 4.125 11.9741H9.57938C10.2007 11.9741 10.7044 11.4705 10.7044 10.8491V4.125C10.7044 3.50368 10.2007 3 9.57938 3Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8528 3H14.3984C13.7771 3 13.2734 3.50368 13.2734 4.125V5.727C13.2734 6.34834 13.7771 6.852 14.3984 6.852H19.8528C20.4741 6.852 20.9778 6.34834 20.9778 5.727V4.125C20.9778 3.50368 20.4741 3 19.8528 3Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.8528 9.41992H14.3984C13.7771 9.41992 13.2734 9.92358 13.2734 10.5449V19.852C13.2734 20.4734 13.7771 20.977 14.3984 20.977H19.8528C20.4741 20.977 20.9778 20.4734 20.9778 19.852V10.5449C20.9778 9.92358 20.4741 9.41992 19.8528 9.41992Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.57938 14.5566H4.125C3.50368 14.5566 3 15.0603 3 15.6816V19.852C3 20.4733 3.50368 20.977 4.125 20.977H9.57938C10.2007 20.977 10.7044 20.4733 10.7044 19.852V15.6816C10.7044 15.0603 10.2007 14.5566 9.57938 14.5566Z"
          stroke="#676A79"
          stroke-width="1"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
  );
};

export const NetworkSVG = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16055 10.87C9.06055 10.86 8.94055 10.86 8.83055 10.87C6.45055 10.79 4.56055 8.84 4.56055 6.44C4.56055 3.99 6.54055 2 9.00055 2C11.4505 2 13.4405 3.99 13.4405 6.44C13.4305 8.84 11.5405 10.79 9.16055 10.87Z"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4093 4C18.3493 4 19.9093 5.57 19.9093 7.5C19.9093 9.39 18.4093 10.93 16.5393 11C16.4593 10.99 16.3693 10.99 16.2793 11"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.1607 14.56C1.7407 16.18 1.7407 18.82 4.1607 20.43C6.9107 22.27 11.4207 22.27 14.1707 20.43C16.5907 18.81 16.5907 16.17 14.1707 14.56C11.4307 12.73 6.9207 12.73 4.1607 14.56Z"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
        stroke="#667085"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ContactSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.93745 4.45845C3.8798 3.46577 4.21283 3.18735 4.6144 3.05777C4.89231 2.98496 5.18377 2.98091 5.46359 3.04599C5.83197 3.15308 5.92941 3.23447 7.13731 4.43811C8.19852 5.49504 8.30454 5.60962 8.40627 5.8163C8.60084 6.17908 8.63125 6.60765 8.48979 6.99424C8.38271 7.28872 8.23065 7.48362 7.58707 8.12934L7.16729 8.55024C7.0571 8.66225 7.03118 8.8323 7.10304 8.97216C8.03575 10.5632 9.3589 11.8901 10.9474 12.8272C11.1303 12.9251 11.3555 12.8935 11.5043 12.7491L11.908 12.3518C12.1575 12.0959 12.4218 11.855 12.6993 11.63C13.1354 11.3623 13.6786 11.3384 14.1364 11.5668C14.3602 11.6739 14.4341 11.7403 15.5285 12.8326C16.6572 13.9581 16.6893 13.9934 16.8135 14.2515C17.0473 14.6786 17.0449 15.1961 16.8071 15.6211C16.6861 15.861 16.6122 15.9477 15.9772 16.5966C15.5938 16.9886 15.233 17.3462 15.1751 17.3987C14.6513 17.8324 13.9792 18.0452 13.3011 17.992C12.0607 17.8789 10.8599 17.4954 9.78339 16.8686C7.39881 15.6051 5.36871 13.7643 3.87873 11.5144C3.55419 11.0434 3.26567 10.5487 3.01562 10.0344C2.34481 8.88467 1.99841 7.57457 2.0133 6.24357C2.06451 5.54725 2.39843 4.90224 2.93745 4.45845Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PrivacySVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 8.68066C2.5 6.01597 2.5 4.68365 2.8146 4.23542C3.12919 3.7872 4.38193 3.35838 6.88742 2.50074L7.36477 2.33735C8.67083 1.89028 9.32383 1.66675 10 1.66675C10.6762 1.66675 11.3292 1.89028 12.6352 2.33735L13.1126 2.50074C15.6181 3.35838 16.8708 3.7872 17.1854 4.23542C17.5 4.68365 17.5 6.01597 17.5 8.68066C17.5 9.08308 17.5 9.51958 17.5 9.99291C17.5 14.6912 13.9675 16.9713 11.7512 17.9395C11.15 18.2021 10.8494 18.3334 10 18.3334C9.15058 18.3334 8.85 18.2021 8.2488 17.9395C6.03247 16.9713 2.5 14.6912 2.5 9.99291C2.5 9.51958 2.5 9.08308 2.5 8.68066Z"
        stroke="#676A79"
      />
      <path
        d="M10 9.16659C10.9205 9.16659 11.6667 8.42039 11.6667 7.49992C11.6667 6.57944 10.9205 5.83325 10 5.83325C9.07953 5.83325 8.33333 6.57944 8.33333 7.49992C8.33333 8.42039 9.07953 9.16659 10 9.16659Z"
        stroke="#676A79"
      />
      <path
        d="M13.3333 12.4999C13.3333 13.4204 13.3333 14.1666 10 14.1666C6.66667 14.1666 6.66667 13.4204 6.66667 12.4999C6.66667 11.5794 8.15905 10.8333 10 10.8333C11.8409 10.8333 13.3333 11.5794 13.3333 12.4999Z"
        stroke="#676A79"
      />
    </svg>
  );
};

export const TermsAndConditionsSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.15 6.69936L15.5362 6.31316C16.1761 5.67328 17.2136 5.67328 17.8534 6.31316C18.4933 6.95303 18.4933 7.99048 17.8534 8.63033L17.4672 9.01658M15.15 6.69936C15.15 6.69936 15.1983 7.52003 15.9224 8.24416C16.6466 8.96825 17.4672 9.01658 17.4672 9.01658M15.15 6.69936L11.5995 10.2498C11.359 10.4903 11.2387 10.6106 11.1353 10.7432C11.0134 10.8996 10.9088 11.0688 10.8235 11.2478C10.7512 11.3997 10.6973 11.5609 10.5898 11.8836L10.2455 12.9166L10.1341 13.2508M17.4672 9.01658L13.9167 12.5671C13.6762 12.8076 13.556 12.9278 13.4234 13.0313C13.267 13.1532 13.0977 13.2578 12.9187 13.3431C12.7669 13.4154 12.6057 13.4693 12.283 13.5768L11.25 13.9211L10.9158 14.0325M10.1341 13.2508L10.0227 13.585C9.96975 13.7437 10.0111 13.9188 10.1294 14.0372C10.2477 14.1555 10.4228 14.1968 10.5816 14.1439L10.9158 14.0325M10.1341 13.2508L10.9158 14.0325"
        stroke="#676A79"
      />
      <path d="M6.66667 10.8333H8.75" stroke="#676A79" stroke-linecap="round" />
      <path d="M6.66667 7.5H12.0833" stroke="#676A79" stroke-linecap="round" />
      <path
        d="M6.66667 14.1667H7.91667"
        stroke="#676A79"
        stroke-linecap="round"
      />
      <path
        d="M2.5 8.33341C2.5 5.19071 2.5 3.61937 3.47631 2.64306C4.45262 1.66675 6.02397 1.66675 9.16667 1.66675H10.8333C13.976 1.66675 15.5474 1.66675 16.5237 2.64306C17.5 3.61937 17.5 5.19071 17.5 8.33341V11.6667C17.5 14.8094 17.5 16.3808 16.5237 17.3571C15.5474 18.3334 13.976 18.3334 10.8333 18.3334H9.16667C6.02397 18.3334 4.45262 18.3334 3.47631 17.3571C2.5 16.3808 2.5 14.8094 2.5 11.6667V8.33341Z"
        stroke="#676A79"
      />
    </svg>
  );
};

export const InviteFriendsSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 8.33341C11.1743 8.33341 12.6667 6.84103 12.6667 5.00008C12.6667 3.15913 11.1743 1.66675 9.33333 1.66675C7.49238 1.66675 6 3.15913 6 5.00008C6 6.84103 7.49238 8.33341 9.33333 8.33341Z"
        stroke="#676A79"
      />
      <path
        d="M17.5 8.33329H15.8333M15.8333 8.33329H14.1667M15.8333 8.33329V6.66663M15.8333 8.33329V9.99996"
        stroke="#676A79"
        stroke-linecap="round"
      />
      <path
        d="M15.998 14.9999C16.0001 14.8631 16.0001 14.7241 16.0001 14.5833C16.0001 12.5122 13.0153 10.8333 9.33341 10.8333C5.65151 10.8333 2.66675 12.5122 2.66675 14.5833C2.66675 16.6543 2.66675 18.3333 9.33341 18.3333C11.1926 18.3333 12.5332 18.2027 13.5001 17.9694"
        stroke="#676A79"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const SignOutSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.87463 7.80599C5.14299 7.5463 5.14407 7.12419 4.87705 6.86318C4.61002 6.60219 4.176 6.60114 3.90762 6.86084L4.87463 7.80599ZM1.15198 9.52746C0.883618 9.7872 0.882539 10.2093 1.14957 10.4703C1.41659 10.7313 1.85062 10.7324 2.11899 10.4727L1.15198 9.52746ZM2.11899 9.52746C1.85062 9.26782 1.41659 9.26888 1.14957 9.52986C0.882539 9.79084 0.883618 10.213 1.15198 10.4727L2.11899 9.52746ZM3.90762 13.1394C4.176 13.399 4.61002 13.398 4.87705 13.137C5.14407 12.876 5.14299 12.4539 4.87463 12.1941L3.90762 13.1394ZM1.63548 9.33342C1.2569 9.33342 0.95 9.63191 0.95 10.0001C0.95 10.3683 1.2569 10.6668 1.63548 10.6668V9.33342ZM14.4312 10.6668C14.8098 10.6668 15.1167 10.3683 15.1167 10.0001C15.1167 9.63191 14.8098 9.33342 14.4312 9.33342V10.6668ZM3.90762 6.86084L1.15198 9.52746L2.11899 10.4727L4.87463 7.80599L3.90762 6.86084ZM1.15198 10.4727L3.90762 13.1394L4.87463 12.1941L2.11899 9.52746L1.15198 10.4727ZM1.63548 10.6668H14.4312V9.33342H1.63548V10.6668Z"
        fill="#676A79"
      />
      <path
        d="M7.61667 12.8571C7.61667 14.961 9.23345 16.6666 11.2278 16.6666H14.8389C16.8332 16.6666 18.45 14.961 18.45 12.8571V7.14278C18.45 5.03883 16.8332 3.33325 14.8389 3.33325H11.2278C9.23345 3.33325 7.61667 5.03883 7.61667 7.14278"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShoppingListSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.0136 5.89387V16.4645C16.0136 17.8137 15.0458 18.3813 13.8641 17.73L10.2072 15.6921C9.81638 15.4781 9.18362 15.4781 8.79281 15.6921L5.13592 17.73C3.95417 18.3813 2.98645 17.8137 2.98645 16.4645V5.89387C2.98645 4.3027 4.28915 3 5.88032 3H13.1197C14.7108 3 16.0136 4.3027 16.0136 5.89387Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FavoritesSVG = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.2563 2.41842C9.49192 1.8949 9.60978 1.63313 9.77385 1.55253C9.91635 1.48249 10.0837 1.48249 10.2262 1.55253C10.3902 1.63313 10.5081 1.8949 10.7437 2.41842L12.6206 6.58836C12.6903 6.74312 12.7251 6.8205 12.779 6.87976C12.8267 6.9322 12.885 6.97414 12.95 7.00284C13.0236 7.0353 13.1087 7.04419 13.2789 7.06197L17.8634 7.54118C18.4389 7.60133 18.7267 7.63141 18.8548 7.76103C18.966 7.87361 19.0178 8.03126 18.9945 8.18713C18.9679 8.36655 18.7529 8.55837 18.323 8.9421L14.8984 11.9985C14.7714 12.1119 14.7078 12.1686 14.6676 12.2377C14.6319 12.2989 14.6096 12.3667 14.6022 12.4369C14.5938 12.5162 14.6115 12.599 14.647 12.7649L15.6035 17.2309C15.7236 17.7916 15.7837 18.072 15.6988 18.2326C15.625 18.3723 15.4896 18.4697 15.3328 18.496C15.1522 18.5263 14.9016 18.3831 14.4002 18.0968L10.4068 15.8157C10.2586 15.731 10.1845 15.6888 10.1058 15.6722C10.036 15.6576 9.96398 15.6576 9.89426 15.6722C9.81548 15.6888 9.74139 15.731 9.59319 15.8157L5.59986 18.0968C5.09851 18.3831 4.84783 18.5263 4.66726 18.496C4.51041 18.4697 4.375 18.3723 4.30127 18.2326C4.2164 18.072 4.27644 17.7916 4.39653 17.2309L5.35302 12.7649C5.38852 12.599 5.40627 12.5162 5.39784 12.4369C5.39038 12.3667 5.36812 12.2989 5.3325 12.2377C5.29225 12.1686 5.2287 12.1119 5.1016 11.9985L1.67708 8.9421C1.24715 8.55837 1.03218 8.36655 1.00545 8.18713C0.982243 8.03126 1.03396 7.87361 1.14524 7.76103C1.27337 7.63141 1.56115 7.60133 2.13672 7.54118L6.7212 7.06197C6.89136 7.04419 6.97643 7.0353 7.05 7.00284C7.11508 6.97414 7.17336 6.9322 7.22106 6.87976C7.27495 6.8205 7.30978 6.74312 7.37945 6.58836L9.2563 2.41842Z"
        stroke="#676A79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
